import React, { useState, memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import AssignManagerTable from "@/components/project-dashboard/account-holder-main/assign-manager/AssignManagerTable"
import InviteNewPerson from "@/components/project-dashboard/account-holder-main/assign-manager/InviteNewPerson"
import { useNavigate } from "react-router-dom"
import { urlPath } from "@/utils"

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(3),
    },
    assignManagerPageButton: {
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
}))

const AssignManager = memo((props) => {
    const { userCompanyId, userId } = props
    const classes = useStyles()
    const navigate = useNavigate()
    const [addNewPersonOpen, setAddNewPersonOpen] = useState(false)

    const inviteNewPerson = () => {
        setAddNewPersonOpen((prev) => !prev)
    }
    return (
        <Box className={classes.wrapper}>
            <Box mb={3}>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.assignManagerPageButton}
                    onClick={() => navigate(urlPath("account-holder-main", userId))}
                >
                    Home Page
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.assignManagerPageButton}
                    onClick={() => navigate(urlPath("dashboard", userId))}
                >
                    Project Dashboard
                </Button>
                <Button variant="contained" color="primary" className={classes.assignManagerPageButton} onClick={inviteNewPerson}>
                    Create a New Project Manager
                </Button>
            </Box>
            {addNewPersonOpen && (
                <Box mt={3}>
                    <InviteNewPerson userCompanyId={userCompanyId} />
                </Box>
            )}
            <Box mt={3}>
                <AssignManagerTable userCompanyId={userCompanyId} />
            </Box>
        </Box>
    )
})

export default AssignManager
